import React, { Component } from "react";
import "./Navbar.css";
import PostApiCall from "../Helper/PostApi";
import Notiflix from "notiflix";
import { Navbar, Container, Col } from "react-bootstrap";
import "./Navbar.css";
import logoholexo from "../images/Logo/holexo.png";

class Navbar1mobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      suggestions: [],
      text: "",
      productCart: [],
      searchText: "",
      loginData: [],
      open: false,
      openmenu: false,
      nav: false,
      MyProfile: false,
      windowWidth: window.innerWidth,
      DefaultPincode: null,
      CartAmount: 0,
      StateId: 0,
      MyAccount: "",
      Name: "",
    };
  }
  selectedText(value) {
    this.setState(() => ({
      text: value,
      suggestions: [],
      Menubcolorbackaground: "transparent",
    }));
  }
  componentDidMount() {
    Notiflix.Loading.init({
      svgColor: "#ee1b2f",
    });

    // For User login
    var login = localStorage.getItem("CustomerData");
    var logindetails = JSON.parse(login);

    if (logindetails != null) {
      this.setState({
        loginData: logindetails[0],
        Name: logindetails[0].fld_name,
      });
    }
    if (localStorage.getItem("ChangedPincode") == null) {
      this.setState({
        open: true,
      });
    }
    if (this.state.suggestions.length == 0) {
      PostApiCall.postRequest(
        {
          destinationName: "",
        },
        "Searchdestination"
      ).then((results) =>
        results.json().then((obj1) => {
          if (results.status == 200 || results.status == 201) {
            this.setState({
              suggestions: obj1.data,
            });
          }
        })
      );
    }
  }
  render() {
    const { text, suggestions } = this.state;
    return (
      <Navbar
        bg="dark"
        variant="dark"
        expand="lg"
        className={
          this.state.Menubcolorbackaground == "transparent" ? "px-2" : "px-1"
        }
      >
        <Container fluid>
          <Col
            xs
            lg="12"
            md="12"
            className="logocol d-flex justify-content-center"
          >
            <Navbar.Brand
              href="/"
              className="navbar-mobile-logo phnlogorigthmargin"
            >
              <img
                src={logoholexo}
                alt=""
                className="logoSize me-auto ms-auto phnlogosize"
              />
            </Navbar.Brand>
          </Col>
        </Container>
      </Navbar>
    );
  }
}
export default Navbar1mobile;
